import { Text } from "@ui-kitten/components";
import Button from "components/Button";
import React from "react";
import { Pressable, View } from "react-native";
import { CheckoutUpgrade, PAPER } from "../helpers";

const APPLIED_BORDER = "#74a786";
const APPLIED_BACKGROUND = "#edf7f0";

interface Props {
  upgrade: CheckoutUpgrade;
  deltaLabel: string;
  primaryColor: string;
}

// Checkout upgrade promo (prototype's fgm-upgrade-card). Rendered before
// payment — the documented non-tokenized placement — so accepting simply
// swaps the plan ahead of tokenization.
const UpgradeTileV3 = ({ upgrade, deltaLabel, primaryColor }: Props) => {
  const {
    applied,
    headline,
    note,
    benefits,
    onAccept,
    onUndo,
    onDismiss,
  } = upgrade;
  const destinationName = upgrade.destinationProduct.name;
  const destinationVariantLabel = upgrade.destinationLive.variant.label;
  if (applied) {
    return (
      <View
        testID="v3-upgrade-applied"
        className="border rounded-2xl p-4 my-3"
        style={{
          borderColor: APPLIED_BORDER,
          backgroundColor: APPLIED_BACKGROUND,
        }}
      >
        <View className="flex-row justify-between items-center">
          <View className="flex-1 pr-2">
            <Text category="s1">✓ Upgrade applied</Text>
            <Text category="c1" appearance="hint">
              {destinationName} · {destinationVariantLabel}
            </Text>
          </View>
          <Pressable testID="v3-upgrade-undo" onPress={onUndo}>
            <Text category="s2" style={{ color: primaryColor }}>
              Undo
            </Text>
          </Pressable>
        </View>
      </View>
    );
  }

  return (
    <View
      testID="v3-upgrade-offer"
      className="border rounded-2xl p-4 my-3"
      style={{ borderColor: primaryColor, backgroundColor: PAPER }}
    >
      <View className="flex-row justify-between items-start">
        <View className="flex-1 pr-2">
          <Text
            category="c1"
            appearance="hint"
            style={{ fontWeight: "600", letterSpacing: 1 }}
          >
            {(headline || "Upgrade your order").toUpperCase()}
          </Text>
          <Text category="h6">{destinationName}</Text>
          <Text category="c1" appearance="hint">
            {destinationVariantLabel}
          </Text>
        </View>
        <Text category="s1" style={{ color: primaryColor }}>
          {deltaLabel}
        </Text>
      </View>

      {benefits.length ? (
        <View className="mt-3" style={{ gap: 6 }}>
          {benefits.map((benefit) => (
            <View key={benefit} className="flex-row" style={{ gap: 8 }}>
              <Text category="s2" style={{ color: APPLIED_BORDER }}>
                ✓
              </Text>
              <Text category="p2" className="flex-1">
                {benefit}
              </Text>
            </View>
          ))}
        </View>
      ) : null}

      <View className="flex-row items-center mt-3" style={{ gap: 12 }}>
        <View className="flex-1">
          <Button testID="v3-upgrade-accept" size="small" onPress={onAccept}>
            Upgrade my order
          </Button>
        </View>
        <Pressable testID="v3-upgrade-dismiss" onPress={onDismiss}>
          <Text category="s2" appearance="hint">
            No thanks
          </Text>
        </Pressable>
      </View>
      {note ? (
        <Text category="c1" appearance="hint" style={{ marginTop: 8 }}>
          {note}
        </Text>
      ) : null}
    </View>
  );
};

export default UpgradeTileV3;
